import { defineMessages } from 'react-intl';

export default defineMessages({
	header: {
		id: 'paymentWithPaymentElement.header',
		defaultMessage: "Great! Let's review your order details.",
		description: 'Header shown to the user on the checkout page.',
	},
	ctaHeader: {
		id: 'paymentWithPaymentElement.ctaHeader',
		defaultMessage: 'Prefer to speak with a specialist first?',
		description:
			'Header message in the call to action asking the user if they would rather speak with a specialist before purchasing.',
	},
	ctaBody: {
		id: 'paymentWithPaymentElement.ctaBody',
		defaultMessage:
			'Connect with our team to learn how to achieve the results that matter most to your organization. Have questions about billing? We can also provide you with an invoice tailored to your needs.',
		description:
			'Body text in the call to action telling the user why they might want to speak with a specialist.',
	},
	ctaButton: {
		id: 'paymentWithPaymentElement.ctaButton',
		defaultMessage: 'Book a Consultation',
		description:
			'Button text for the call to action prompting the user to schedule a call with a specialist.',
	},
});
